<template>
  <div class="game-login">
    <div class="login-head"></div>
    <div class="login-title">
      <h1>登录</h1>
      <img src="@/assets/images/split-line.png" alt="" />
    </div>

    <div class="login-form">
      <van-form>
        <van-field
          v-model="phone"
          label=""
          left-icon="phone"
          placeholder="请输入手机号码"
          maxlength="11"
          @blur="phoneValidate"
        >
          <img
            class="icon-phone"
            src="@/assets/images/phone.png"
            slot="left-icon"
            name="phone"
            alt=""
          />
        </van-field>
        <van-field
          v-model="picCode"
          type="text"
          label=""
          left-icon="image-code"
          placeholder="请输入图形验证码"
          v-if="picCodeStatus == 1"
        >
          <img
            class="icon-msgcode"
            src="@/assets/images/image-code.png"
            slot="left-icon"
            name="image-code"
            alt=""
          />

          <img @click="getPicCodeUrl" class="pic-code" slot="right-icon" :src="picCodeUrl" alt="" />
        </van-field>
        <van-field
          v-model="msgCode"
          type="number"
          label=""
          left-icon="icon-msgcode"
          placeholder="请输入手机验证码"
        >
          <img
            class="icon-msgcode"
            src="@/assets/images/msg-code.png"
            slot="left-icon"
            name="phone"
            alt=""
          />
          <template #button>
            <van-button
              :disabled="verifyContent.disabled"
              size="small"
              type="primary"
              @click="obtainVerifyCode"
              >{{ verifyContent.text }}</van-button
            >
          </template>
        </van-field>
        <div style="margin-top: 40px" class="login-btn">
          <van-button round block type="info" color="#FF7A3E" @click="onSubmit"
            >立即登录</van-button
          >
        </div>
      </van-form>
    </div>

    <div class="login-protocol">
      <img
        class="icon-status"
        @click="toggleStatus"
        v-if="status"
        src="@/assets/images/ic_status_five.png"
        alt=""
      />
      <img
        class="icon-status"
        @click="toggleStatus"
        v-else
        src="@/assets/images/ic_status_ok.png"
        alt=""
      />
      <span>我已阅读并同意<em>《服务协议》</em><em>《隐私协议》</em></span>
    </div>

    <van-dialog
      v-model="showTipDialog"
      title="请阅读并同意以下条款"
      show-cancel-button
      confirm-button-color="#ff7a3e"
      cancel-button-color="black"
      @confirm="tipDialogConfirm"
    >
      <span>我已阅读并同意<em>《服务协议》</em><em>《隐私协议》</em></span>
    </van-dialog>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapActions, mapGetters } from "vuex";
const os = require("os");
export default {
  name: "Login",
  data() {
    return {
      phone: "",
      msgCode: "",
      picCode: "",
      picCodeUrl: "", //图形验证码url
      status: true, //radio协议图标
      picCodeStatus: 2, //是否需要图形验证码
      token: "", //登录下一步获取token
      needIp: "", //ip地址
      // 获取验证码按钮
      verifyContent: {
        disabled: false,
        text: "获取验证码",
      },
      showTipDialog: false,
    };
  },
  computed: {
    ...mapGetters(["deviceId"]),
  },
  watch: {
    deviceId() {
      this.checkPicCode();
      if (this.picCodeStatus == 1) {
        this.getPicCodeUrl();
      }
    },
    picCodeStatus(val) {
      if(val == 1) {
        this.getPicCodeUrl();
      }
    }
  },
  async mounted() {
    this.getIp()
  },
  methods: {
    ...mapActions(["updateUuid", "updateUserInfo"]),

    onSubmit() {
      console.log(values, "onSubmit----");
      let values = {
        phone: this.phone,
        picCode: this.picCode,
        msgCode: this.msgCode,
      };
      const error = this.validate(values);
      if (error) {
        this.$toast({
          message: error,
          position: "bottom",
        });

        return;
      }
      if (this.status) {
        this.showTipDialog = true;
        return;
      }
      this.login();
    },

    toggleStatus() {
      this.status = !this.status;
    },

    /**
     * 上报用户设备标识ip
     */
    async getIp() {
      fetch("https://v4.ip.zxinc.org/getip")
        .then((response) => response.text())
        .then((data) => {
          this.needIp = data
        })
        .catch((error) => {
          this.$toast(error)
        });
    },

    /**
     * 协议弹窗确认
     */
    tipDialogConfirm() {
      this.status = false
      this.login()
    },

    /**
     * 检查是否需要图形验证码
     */
    async checkPicCode() {
      try {
        const { data } = await requestMethods(
          "/modules/user/user/checkPicCode.htm",
          "post",
          {
            deviceNo: this.deviceId,
            appType: "WM",
          }
        );
        const { picCodeStatus } = data;
        this.picCodeStatus = picCodeStatus;
      } catch (err) {
        // 通过 err.message 获取到错误信息
        console.log(err.message);
      }
    },

    /**
     * 点击获取验证码按钮
     */
    async obtainVerifyCode() {
      // 校验手机号并再次调用next接口
      // 判断手机号格式是否正确
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$toast({
          message: "请输入正确的手机号！",
          position: "bottom",
        });
        return
      } 
      await this.loginNext()
      this.sendPicCodeDetermine();
    },

    /**
     * 根据是否需要图形验证码处理
     */
    async sendPicCodeDetermine() {
      if(this.picCodeStatus == 1) {
        if(!this.picCode) {
          this.$toast({
            message: "请输入图形验证码！",
            position: "bottom",
          });
          return
        }
        if (!/^1[3-9]\d{9}$/.test(this.phone)) {
          this.$toast({
            message: "请输入正确的手机号！",
            position: "bottom",
          });
          return
        } 
        await this.sendMsgCode();
        
      } else {
        await this.sendMsgCode();
      }
    },


    /**
     * 发送短信验证码
     */
    async sendMsgCode() {
      try {
        await requestMethods("/modules/user/sms/send.htm", "post", {
          deviceNo: this.deviceId,
          phone: this.phone,
          picCode: this.picCode,
          status: this.picCodeStatus,
          channel: "ios",
          token: this.token,
          appType: "WM",
        });
        this.countDown();
      } catch (error) {
        console.log(error.message, 'error')
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },
    /**
     * 短信验证码倒计时
     */
    // 倒计时方法
    countDown() {
      var time = 60;
      var timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.verifyContent.disabled = false;
          this.verifyContent.text = "获取验证码";
        } else {
          this.verifyContent.disabled = true;
          this.verifyContent.text = `${time}秒后获取`;
          time--;
          console.log("time", time);
        }
      }, 1000);
    },

    /**
     * 登录submit
     */
    async login() {
      try {
        const { data } = await requestMethods(
          "/modules/user/user/login.htm",
          "post",
          {
            phone: this.phone,
            picCode: this.picCode,
            smsCode: this.msgCode,
            channel: "ios",
            appType: "WM",
            deviceNo: this.deviceId,
            ip: this.needIp,
            token: this.token,
            imei_0: this.deviceId,
            imei_1: this.deviceId,
            OAID: this.deviceId,
          }
        );
        const { uuid } = data;
        this.updateUuid(uuid);
        this.updateUserInfo(data)
        // 返回上一页
        this.$router.go(-1);
      } catch (err) {
        this.$toast({
          message: err.message,
          position: "bottom",
        });
      }
    },

    /**
     * 登录下一步
     */
    async loginNext() {
      try {
        const { data } = await requestMethods(
          "/modules/user/user/next.htm",
          "post",
          {
            phone: this.phone,
            appType: "WM",
            deviceNo: this.deviceId,
          }
        );
        const { token, picCodeStatus } = data;
        this.picCodeStatus = picCodeStatus;
        this.token = token;
      } catch (error) {}
    },

    /**
     * 获取图形验证码
     */
    getPicCodeUrl() {
      this.picCodeUrl = ''
      const checkCodePic = `https://app.wmsy666.com/modules/user/user/pic.htm?phone=${this.phone}&nocache=${Date.now()}`
      this.picCodeUrl = checkCodePic

    },

    /**
     * 表单数据校验
     */
    validate(values) {
      if (!values.phone) {
        return "请输入手机号码！";
      } else if (!/^1[3-9]\d{9}$/.test(values.phone)) {
        return "请输入正确的手机号！";
      }
      if (this.picCodeStatus == 1) {
        if (!values.picCode) {
          return "请输入图形验证码！";
        }
      }
      if (!values.msgCode) {
        return "请输入手机验证码！";
      }
      return null;
    },

    /**
     * 手机号输入项失焦后格式校验
     */
    async phoneValidate() {
      // 判断手机号格式是否正确
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$toast({
          message: "请输入正确的手机号！",
          position: "bottom",
        });
      } else {
        // 调用next接口判断图形验证码是否显示
        await this.loginNext();

        // if(this.picCodeStatus == 1) {
        //   if(!this.picCode) {
        //     this.$toast({
        //       message: "请输入图形验证码！",
        //       position: "bottom",
        //     });
        //   } else {
        //     await this.sendMsgCode();
        //     this.countDown();
        //   }
        // }
      }
    }
  },
};
</script>

<style lang="scss">
.game-login {
  .login-head {
    width: 750px;
    height: 478px;
    background: url("~@/assets/images/head-bg.png");
    background-size: 100% 100%;
  }

  .login-title {
    margin-left: 85px;
    margin-bottom: 20px;
    h1 {
      font-weight: 600;
      font-size: 40px;
      color: #000000;
    }
    img {
      width: 80px;
      height: 10px;
    }
  }
  .login-form {
    // padding: 0 100px;
    .van-form {
      padding: 0 100px;
    }
    .icon-phone,
    .icon-msgcode {
      width: 40px;
      height: 40px;
    }
    .pic-code {
      width: 150px;
      height: 60px;
    }
    .van-cell {
      height: 120px;
      padding-top: 40px;
    }

    .login-btn {
      .van-button {
        height: 80px;
        border-radius: 40px;
      }
    }
  }
  .van-field__left-icon,
  .van-cell__value {
    display: flex;
    align-items: center;
  }
  .van-field__error-message {
    display: none;
  }
  .van-field__button,
  .van-button {
    border-radius: 30px;
    background: #fff;
    color: #ff7a3e;
    border-color: #ff7a3e;
  }
  .van-button {
    padding: 0 30px;
    height: 60px;
  }

  .login-protocol {
    padding: 0 120px;
    height: 40px;
    position: fixed;
    bottom: 10px;
    text-align: center;
    display: flex;
    align-items: center;
    .icon-status {
      width: 30px;
      margin-right: 8px;
    }
    span {
      font-size: 22px;
      color: #8f8f8f;

      em {
        color: #ff7a3e;
      }
    }
  }
  .van-dialog__content {
    text-align: center;
    margin: 50px 0px;
    span {
      font-size: 26px;
      color: #8f8f8f;

      em {
        color: #ff7a3e;
      }
    }
  }
  .van-dialog__footer {
    height: 80px;

    .van-button {
      height: 80px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/index.vue